import { API } from "aws-amplify";

import SyncedAPI from "data/libs/syncedAPI";

import { getAPIReq } from "./authLib";

export const AddLink = async (request) => {
  const req = await getAPIReq(request);
  return SyncedAPI.post("HublyAPI", `/links/`, req);
};

export const GetLink = async (id) => {
  const req = await getAPIReq();
  return API.get("HublyAPI", `/links/${id}/`, req);
};

export const EditLink = async (id, request) => {
  const req = await getAPIReq(request);
  return SyncedAPI.put("HublyAPI", `/links/${id}/`, req);
};

export const DeleteLink = async (id) => {
  const req = await getAPIReq();
  return SyncedAPI.del("HublyAPI", `/links/${id}/`, req);
};
